<template>
  <div class="tab-content-three__container">

    <!-- head -->
    <div class="content__head">
      <h2 class="content__head-title">{{ sparePartsMapping.title }}</h2>
      <p class="content__head-text" v-html="$convertPxToRem(sparePartsMapping.content)"></p>
    </div>

    <!-- img01 -->
    <div class="content__body__img-one"></div>

    <div class="parts-desc__box flex f-jus-center">
      <!-- left -->
      <div class="parts-desc__item parts-desc__left">
        <div class="parts-desc__img"></div>
        <div class="parts-desc__title">{{ sparePartsMapping.group1[0].title }}</div>
        <div class="parts-desc__text">
          {{ sparePartsMapping.group1[0].content }}
        </div>
      </div>
      <!-- right -->
      <div class="parts-desc__item parts-desc__right">
        <div class="parts-desc__title" style="margin-top:200px;">{{ sparePartsMapping.group1[1].title }}</div>
        <div class="parts-desc__text">{{ sparePartsMapping.group1[1].content }}</div>
        <div class="parts-desc__img"></div>
      </div>
    </div>


    <!-- img02 -->
    <div class="content__body__flow-box flex f-center">
      <img :src="sparePartsMapping.flowImg" class="content__body__flow-img" />
    </div>

    <!-- 获益列表 -->
    <div class="content__rights-list flex f-column f-center">
      <ul class="flex f-jus-center">
        <li
        class="content__rights-item"
        v-for="(rights, i) in sparePartsMapping.rights_list"
        :key="i">
        <h3 class="content__rights-item__title">
          <span style="padding-right:2px;">●</span>
          <span>{{ sparePartsMapping.rights_list_title }}</span>
        </h3>
          <p class="content__rights-item__txt">{{ rights }}</p>
        </li>
      </ul>
    </div>
    <footer-wrap></footer-wrap>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'TabContentThree',

    data() {
        return {
          
        }
    },

    computed: {
      ...mapGetters([
        'currentLang'
      ]),
      sparePartsMapping() {
        return this.currentLang.config.customerServicePage.sparePartsMapping
      },
    },

    created() {

    },

    methods: {}
}
</script>

<style scoped lang="scss">
.content__head {
  width: 1000px;
  height: auto;
  margin: 50px auto 80px;
  text-align: center;

  h2 {
    color: #323232;
    font-weight: normal;
    margin-bottom: 30px;
    font-size: 30px;
  }

  p {
    color: #777777;
  }

  .content__head-text {
    line-height: 1.8;
    font-size: 18px;
    color: #777;
    text-align: justify;
    text-align-last: center;
  }
}


.content__body__img-one {
  height: 550px;
  background: url("../../../../assets/images1/customer_service/khfw14.jpg") no-repeat scroll;
  background-position: center center;
  background-size: cover;
}

.parts-desc__box {
  width: 100%;
  height: 980px;

  .parts-desc__item {
    width: 510px;
  }

  .parts-desc__img {
    width: 600px;
    height: 440px;
  }

  .parts-desc__title {
    margin-bottom: 30px;
    font-size: 26px;
    // font-weight: 500;
    color: #003359;
    // letter-spacing: 2px;
  }

  .parts-desc__text {
    color: #777;
    line-height: 1.6;
    font-size: 16px;
    text-align: justify;
  }

  .parts-desc__left {
    margin-right: 80px;
  }
  .parts-desc__left .parts-desc__img {
    margin: 70px 0 130px;
    background: url("../../../../assets/images1/customer_service/khfw15.jpg") no-repeat scroll;
    background-position: center center;
    background-size: cover;
  }

  .parts-desc__right .parts-desc__img {
    margin-top: 150px;
    background: url("../../../../assets/images1/customer_service/khfw16.jpg") no-repeat scroll;
    background-position: center center;
    background-size: cover;
  }
}

.content__body__flow-box {
  width: 100%;
  height: 620px;
  background: url("../../../../assets/images1/customer_service/khfw17.jpg") no-repeat scroll;
  background-position: center center;
  background-size: cover;

  .content__body__flow-img {
    width: 1050px;
    height: 340px;
  }
}


.content__rights-list {
  width: 100%;
  height: 310px;

  .content__rights-item {
    width: 200px;
    margin-right: 30px;
  }
  .content__rights-item:last-child {
    margin-right: 0;
  }

  .content__rights-item__title {
    margin-bottom: 20px;
    font-size: 22px;
    font-weight: 500;
    letter-spacing: 1px;
    color: #0F335E;
  }

  .content__rights-item__txt {
    color: #777;
    line-height: 1.6;
    text-align: justify;
    font-size: 18px;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/home/home_customer_service/components/TabContentThree.vue